export default (params) => `
  <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:web="http://webservice/">
    <soapenv:Header/>
    <soapenv:Body>
      <web:getCountryCities>
        <countryId>${params.countryId}</countryId>
        <userId>${params.userId}</userId>
        <userKey>${params.userKey}</userKey>
      </web:getCountryCities>
    </soapenv:Body>
  </soapenv:Envelope>
`
